import SubscriptionService from '@/modules/base/components/subscription/subscriptionService'
import { updateSubscriptionDetails } from '@/redux/ducks/subscription/details'
import { ProductTypes } from '@/modules/base/util/constants'
import { navigate } from '@/modules/layout/util/useInterceptedNavigate'
import { getPostLoginRedirectDecision, RedirectContext } from '@/utils/post-login-redirect'
import { toast } from '@/modules/base/components/toast/toastConfig'
import store from '@/redux/store'
import parseJwt from '@/utils/parseJwt'
import lang from '@/lang'

const MAX_ATTEMPTS = 3

interface TrialState {
  running: boolean
  attempts: number
}

const trialStates = new Map<string, TrialState>()

const getTenantKey = (): string => {
  try {
    return String(parseJwt(store.getState().user?.info?.token)?.tenant ?? '')
  } catch {
    return ''
  }
}

const navigateAfterTrial = (): void => {
  if (window.location?.pathname?.startsWith('/shop')) return

  const { target } = getPostLoginRedirectDecision({
    context: RedirectContext.POST_TRIAL,
    isMeinBuero: false,
  })
  navigate?.(target || '/')
}

const startInitialTrial = (): Promise<void> => {
  if (store.getState().user?.info?.isDemo) return Promise.resolve()

  const tenantKey = getTenantKey()
  const state = trialStates.get(tenantKey) || { running: false, attempts: 0 }
  if (state.running || state.attempts >= MAX_ATTEMPTS) return Promise.resolve()

  state.running = true
  state.attempts += 1
  trialStates.set(tenantKey, state)

  return SubscriptionService.createTrials([ProductTypes.MAIN])
    .then(
      () => updateSubscriptionDetails(true, true)
        .then(navigateAfterTrial)
        .catch(error => console.error(error)),
      error => {
        state.running = false
        console.error(error)
        if (state.attempts >= MAX_ATTEMPTS) {
          toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
        }
      },
    )
}

export default startInitialTrial
